function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Tesoro_Logo_White",
  transform: "translate(-8.44 -4.23)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7035",
  "data-name": "Path 7035",
  d: "M18.959,6.683V30.992h-3.05V6.683H8.44V5.14H26.392V6.683Z",
  transform: "translate(0 -0.695)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7036",
  "data-name": "Path 7036",
  d: "M128.76,30.992V5.14h15.262V6.683H131.813v8.15h12.209v1.543H131.813v13.07h12.209v1.543H128.76Z",
  transform: "translate(-91.846 -0.695)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7037",
  "data-name": "Path 7037",
  d: "M248.7,6.679A5.517,5.517,0,0,0,245.43,5.7c-2.908,0-4.847,1.507-4.847,3.77,0,1.9,1.221,3.124,5.457,5.457A28.906,28.906,0,0,1,251.1,18.3a7.117,7.117,0,0,1,2.407,5.206c0,4.38-3.311,7.218-9.054,7.218h-.208c-3.145-.3-4.745-1.649-6.534-2.965V25.919a22.719,22.719,0,0,0,2.8,2.026,8.175,8.175,0,0,0,4.2,1.1c3.841-.085,6.248-1.976,6.248-4.74,0-2.262-1.8-4.021-6.823-6.714-2.908-1.543-4.451-2.658-5.242-3.7a5.679,5.679,0,0,1-1.186-3.375c0-3.7,3.3-6.283,7.97-6.283,2.227,0,3.28.677,5.575,2.374l-.045,1.844S249.805,7.4,248.7,6.679Z",
  transform: "translate(-175.013)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7038",
  "data-name": "Path 7038",
  d: "M369.992,17.478a12.756,12.756,0,1,1-25.492.071,12.752,12.752,0,1,1,25.492-.071Zm-22.155.073a13.928,13.928,0,0,0,3.053,8.761,8.123,8.123,0,0,0,6.356,2.979,8.418,8.418,0,0,0,7-3.805,14.235,14.235,0,0,0,2.407-7.864c0-6.643-4.094-11.778-9.407-11.778C351.966,5.844,347.837,10.98,347.837,17.551Z",
  transform: "translate(-256.531 -0.107)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7039",
  "data-name": "Path 7039",
  d: "M509.772,30.992l-9.731-14.613H498.1V30.992H495.05V5.14h10.521a5.619,5.619,0,0,1,.036,11.239h-1.976L513.4,30.992ZM503.92,14.836a4.078,4.078,0,0,0,0-8.153H498.1v8.15h5.817Z",
  transform: "translate(-371.454 -0.695)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7040",
  "data-name": "Path 7040",
  d: "M630.222,17.478a12.756,12.756,0,1,1-25.492.071,12.752,12.752,0,1,1,25.492-.071Zm-22.155.073a13.928,13.928,0,0,0,3.053,8.761,8.123,8.123,0,0,0,6.356,2.979,8.418,8.418,0,0,0,7-3.805,14.235,14.235,0,0,0,2.407-7.864c0-6.643-4.094-11.778-9.407-11.778C612.2,5.844,608.067,10.98,608.067,17.551Z",
  transform: "translate(-455.178 -0.107)",
  fill: "#fff"
}));

var SvgTesoroLogo = function SvgTesoroLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166.604,
    height: 26.498,
    viewBox: "0 0 166.604 26.498",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTesoroLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TesoroLogo.cdf1197c.svg";
export { ForwardRef as ReactComponent };